import React, { useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import SEO from '../components/SEO';
import GetSEOData from '../data/SEO';
import AtAGlanceComparison from '../components/location/AtAGlanceComparison';
import SpecialAboutFibre from '../components/location/specialAboutFibre';
import CustomerReview from '../components/CustomerReview';
import PostcodeSearch from '../components/PostcodeSearch';
import ProductInfo from '../components/ProductInfo';
import SwitchToLit from '../components/location/switchToLit';
import ProductTerms from '../components/products/ProductTerms';
import GetCurrentPromotion from '../data/Promotions';
import HeroSection from '../components/HeroSection';
const PostcodeSearchPage = () => {
  const data = imageQuery();

  const [selectedAddress, setSelectedAddress] = useState(undefined);
  const [inputDisplayValue, setInputDisplayValue] = useState('');
  const [selectedPlan, setSelectedPlan] = useState();
  const [selectedBundle, setSelectedBundle] = useState();
  let { title, description } = GetSEOData('postcode-search');

  const promotion = GetCurrentPromotion();

  const productInfoSettings = {
    autoplay: false,
  };

  return (
    <>
      <SEO title={title} description={description} />
      <div className="location-search">
        <PostcodeSearch
          placeholder="Check your availability"
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
          inputDisplayValue={inputDisplayValue}
          setInputDisplayValue={setInputDisplayValue}
        />
      </div>
      <div className="postcode-search-header">
        <HeroSection
          heading="Is your home ready to get Lit?"
          className="NewsheroSection webite_template"
          backgroundImage="hero-images/newsBackground.jpg"
        />
      </div>
      <section className="postcode-search-header-copy">
        <div className="container text-center">
          <div className="col">
            <div className="col-md-12 location-sub-information">
              <ul>
                <li>
                  <span className="checkmark">
                    <div className="checkmark_stem"></div>
                    <div className="checkmark_kick"></div>
                  </span>
                  <p>Full Fibre Broadband starting at just £24 per month</p>
                </li>
                <li>
                  <span className="checkmark">
                    <div className="checkmark_stem"></div>
                    <div className="checkmark_kick"></div>
                  </span>
                  <p>Up to 5x more reliable than "standard" fibre***</p>
                </li>
                <li>
                  <span className="checkmark">
                    <div className="checkmark_stem"></div>
                    <div className="checkmark_kick"></div>
                  </span>
                  <p>
                    Choose 1 of 3 packages to make sure you get the right kind
                    of fast for you{' '}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <ProductInfo
        isLocationPage
        sliderSettings={productInfoSettings}
        setSelectedPlan={setSelectedPlan}
        selectedPlan={selectedPlan}
        setSelectedBundle={setSelectedBundle}
        selectedBundle={selectedBundle}
      />
      <CustomerReview heading="What our customers say" />
      <SwitchToLit />
      <div className="location-search location-search-two mt-5">
        <PostcodeSearch
          placeholder="Check your availability"
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
          inputDisplayValue={inputDisplayValue}
          setInputDisplayValue={setInputDisplayValue}
        />
      </div>
      <SpecialAboutFibre />
      <AtAGlanceComparison />
      <div className="location-search">
        <PostcodeSearch
          placeholder="Check your availability"
          selectedAddress={selectedAddress}
          setSelectedAddress={setSelectedAddress}
          inputDisplayValue={inputDisplayValue}
          setInputDisplayValue={setInputDisplayValue}
        />
      </div>
      <div className="mt-3">
        <ProductTerms promotion={promotion} isMainPage={true} />
        <div className="text-wrap offerTerms">
          **Broadband speed calculations: The UK’s average broadband speeds are
          69.4Mbps for downloads compared to Lit Fibre’s top package average
          speed of 900Mps. Average speeds taken from Ofcom’s ‘UK Home Broadband
          Performance’ report March 2023.
        </div>
      </div>
    </>
  );
};

export default PostcodeSearchPage;

const imageQuery = () =>
  useStaticQuery(graphql`
    {
      PostCodeSearchHeader: file(
        relativePath: { eq: "hero-images/PostCodeSearchHeaderDesktop.jpg" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      PostCodeSearchHeaderMobile: file(
        relativePath: { eq: "hero-images/PostCodeSearchHeaderMobile.jpg" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
    }
  `);
